import $ from 'jquery';
import mapLoader from './yandexmaps.js';

let $mapCanvas = $('.contact-page__map__canvas');

const init = function() {

    if(!$mapCanvas.length) {
        return;
    }

    const poi = $mapCanvas.data('points');

    if(!(Array.isArray(poi) && poi.length)) {
        return;
    }

    const latlng = poi[0].coordinates;
    const zoom = poi[0].zoom || 15;

    if(!latlng) {
        return;
    }

    mapLoader(
        $mapCanvas.get(0),
        {
            center: latlng,
            zoom: zoom
        },
        function(_map)
        {
            const map = _map;

            const points = {
                "type": "FeatureCollection",
                "features": []
            };

            const coords = [];


            Array.prototype.slice.call(poi, 0).forEach(point => {

                coords.push(point.coordinates);

                const placemark = new ymaps.Placemark(point.coordinates, {
                    iconContent: point.title
                }, {
                    preset: 'islands#darkBlueStretchyIcon'
                });

                map.geoObjects.add(placemark);
                console.info('poi', point, placemark);

                /*points.features.push({
                    type: 'Feature',
                    id: point.id,
                    geometry: {
                        type: 'Point',
                        coordinates: point.coordinates
                    },
                    options: {
                        preset: 'islands#darkBlueStretchyIcon'
                    },
                    properties: {
                        iconContent: point.title
                    }
                });*/
            });

            // const objectManger = new ymaps.ObjectManager({
            //     clusterize: false
            // });

            //objectManger.add(points);
            //map.geoObjects.add(objectManger);


            if(poi.length > 1) {
                const mapCenter = ymaps.util.bounds.getCenterAndZoom(ymaps.util.bounds.fromPoints(coords), map.container.getSize(), undefined, {margin: [20, 10]});
                //const mapCenter = ymaps.util.bounds.getCenterAndZoom(objectManger.getBounds(), map.container.getSize());

                map.setCenter(mapCenter.center, mapCenter.zoom);
            }

            // const placemark = new ymaps.Placemark(latlng, {
            //     iconContent: "Азербайджан"
            // }, {
            //     preset: 'islands#darkBlueStretchyIcon'
            // });

            // map.geoObjects.add(placemark);
        }
    );
}

export default init;
